import React from 'react';
import './HowItWorks.css';

const steps = [
  {
    num: '01',
    title: 'Free Consultation',
    desc: 'Book a free 30-minute session with our expert counsellors. We assess your profile, goals, and budget.',
    icon: '💬',
  },
  {
    num: '02',
    title: 'University Shortlisting',
    desc: 'We create a personalised list of universities and programs that perfectly fit your profile.',
    icon: '🎯',
  },
  {
    num: '03',
    title: 'Application & Documents',
    desc: 'We handle your entire application — SOPs, essays, transcripts, references and more.',
    icon: '📄',
  },
  {
    num: '04',
    title: 'Visa & Pre-Departure',
    desc: 'We prepare your visa application and brief you on everything before you fly.',
    icon: '🛫',
  },
  {
    num: '05',
    title: 'Arrival & Settling In',
    desc: 'Our on-ground support team helps you settle, register, and get started on the right foot.',
    icon: '🏫',
  },
];

export default function HowItWorks() {
  return (
    <section className="how-it-works" id="how-it-works">
      <div className="section-inner">
        <div className="section-header">
          <span className="section-tag">Simple Process</span>
          <h2 className="section-title">How It <span className="gold-text">Works</span></h2>
          <p className="section-sub">A clear, guided 5-step journey from decision to destination.</p>
        </div>

        <div className="steps-container">
          {steps.map((s, i) => (
            <div className="step-item" key={i}>
              <div className="step-left">
                <div className="step-num">{s.num}</div>
                {i < steps.length - 1 && <div className="step-line"></div>}
              </div>
              <div className="step-content">
                <div className="step-icon">{s.icon}</div>
                <h3 className="step-title">{s.title}</h3>
                <p className="step-desc">{s.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="hiw-cta">
          <p>Ready to start your journey?</p>
          <a href="#contact" className="btn-primary">Book Free Consultation <span className="btn-arrow">→</span></a>
        </div>
      </div>
    </section>
  );
}
